// extracted by mini-css-extract-plugin
export default {"container":"Select_container__1MizV","wrapper":"Select_wrapper__jd9H8","list":"Select_list__itNGH","item":"Select_item__PPGup"};